import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { zodInsertFeedback } from '../generated/zodSchemas.generated';
import { FeedbackAction, FeedbackRefKey } from '@daymade/common-lib/dbEnums';
import { ZFeedbackContent } from '@daymade/common-lib/dbJsonModels';

export const FeedbackActionEnum = FeedbackAction;
export const FeedbackRefKeyEnum = FeedbackRefKey;

export const ZFeedbackInsert = zodInsertFeedback.extend(
  ensureSubsetOfKeys(zodInsertFeedback.shape, {
    feedback: ZFeedbackContent,
  }),
);
